import portraitContext from './ChatPortraitAssets';

const normalizeName = (name) => String(name || '').trim().normalize('NFC').toLowerCase();

export function buildChatPortraits(context) {
  return Object.fromEntries(context.keys().sort().map((path) => {
    const name = path.replace(/^\.\//, '').replace(/\.[^.]+$/, '');
    const image = context(path);
    return [normalizeName(name), image.default || image];
  }));
}

const portraits = buildChatPortraits(portraitContext);

export function getChatPortrait(name) {
  return portraits[normalizeName(name)] || '';
}
